<template>
  <div :class="[accordionItemClass, $style.item]" :disabled="disabled" v-bind="openAttrs">
    <div :class="[$style.itemInside, module === 'edit-profile' ? $style.itemProfileInside : '']">
      <div :id="headerId" :class="!disableToogleEvent ? $style.heading : $style.noPointerHeading" @click="toggleOpen()">
        <slot name="heading" :open="isOpen" />
      </div>
      <transition-slide :open="isOpen">
        <div v-show="isOpen" :class="$style.itemContent">
          <slot name="content" />
        </div>
      </transition-slide>
    </div>
  </div>
</template>

<script type="text/ecmascript-6">
import TransitionSlide from 'components/transitions/slide-transition'

export default {
  name: 'FouAccordionItem',

  components: {
    TransitionSlide
  },

  props: {
    open: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    disableToogleEvent: {
      type: Boolean,
      default: false
    },
    remote: {
      /**
       * In case you want to open/close the accordion remotly,
       * you can pass Object with open flag, like: { open: true }.
       */
      type: Object,
      default: null
    },
    module: {
      type: String,
      default: ''
    }
  },

  data () {
    // random is safe to use in this case
    return {
      accordionItemClass: 'js-accordion-item',
      openState: this.open,
      headerId: `header-${Math.random().toString(36).substr(2, 9)}` // NOSONAR
    }
  },

  computed: {
    isOpen () {
      return this.hasRemoteOpen()
        ? this.remote.open
        : this.openState
    },
    openAttrs() {
      return this.isOpen ? { open: true } : {}
    }
  },

  mounted () {
    /**
     * Sometimes expand would not render correctly. This helps.
     */
    setTimeout(() => { this.$events?.$emit('fou:expand:update') }, 15)
  },

  methods: {
    hasRemoteOpen () {
      return typeof this.remote?.open === 'boolean'
    },
    toggleOpen () {
      if (this.disableToogleEvent) return;
      if (!this.disabled) {
        if (this.hasRemoteOpen()) {
          this.remote.open = !this.remote.open
        } else {
          this.openState = !this.openState
        }
      }
      /**
       * Expand might need be recalculated.
       */
       this.$events?.$emit('closeOtherItems', this)
      this.$events?.$emit('fou:expand:update')
    }
  }
}
</script>

<style lang="scss" module>
@import 'mpl-css/lib/assets/global/variables/colors';

.itemInside {
  position: relative;
}
.itemProfileInside {
  gap: 0.5rem;
  padding: 1.5rem 2.5rem;
  display: flex;
  flex-direction: column;
}
.itemContent {
  position: relative;
}
.noPointerHeading {
  cursor: default;
}
.heading {
  cursor: pointer;
}
.item[disabled='true'] .heading {
  cursor: default;
  color: map-get($colors, 'grey');
  & > * > * {
    opacity: 0.3;
  }
}
</style>
